// import React, { useState } from 'react';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import { type FormikProps } from 'formik';
// import useGetInventoryCountById from '@hooks/INV/InventoryCount/useGetInventoryCountById';
// import { useParams } from 'react-router-dom';
// import useGetOnhandInventoryItemsByInventoryId from '@hooks/INV/MasterItems/useGetOnhandInventoryItemsByInventoryId';

// interface LinesProps {
//   formik: FormikProps<any>;
// }

// const CountLine: React.FC<LinesProps> = ({ formik }) => {
//   const { values } = formik;
//   const { invCountId } = useParams();
//   const { CountItemsOptions, data } = useGetInventoryCountById({ invCountId: invCountId });

//   const { InventoryItemsOptions, loading, error } = useGetOnhandInventoryItemsByInventoryId({
//     InventoryId: data.inventoryId
//   });

//   const { i18n, t } = useTranslation();
//   const [selectedItem, setSelectedItem] = useState<any>(null);
//   const [selectedUom, setSelectedUom] = useState<any>(null);
//   const [countQuantity, setCountQuantity] = useState<number | string>('');

//   const handleAddLine = () => {
//     if (selectedItem && countQuantity !== '') {
//       const newLine = {
//         ItemId: selectedItem.value,
//         invCountItemsId: selectedItem.invCountItemsId,
//         countQuantity: Number(countQuantity),
//         unitOfMeasure: selectedUom,
//         itemName: InventoryItemsOptions.find(f => f.itemId === selectedItem.value)?.itemName,
//         UomName: InventoryItemsOptions.find(f => f.uom === selectedUom)?.uomName
//       };

//       const updatedLines = [...(values.inventoryCountEntriesLineList || []), newLine];
//       formik.setFieldValue('inventoryCountEntriesLineList', updatedLines);

//       // إعادة تعيين الحقول بعد الإضافة
//       setSelectedItem(null);
//       setSelectedUom(null);
//       setCountQuantity('');
//     }
//   };

//   const handleChange = (field: string, value: any) => {
//     switch (field) {
//       case 'selectedItem':
//         setSelectedItem(value);
//         setSelectedUom(InventoryItemsOptions?.find(f => f.itemId === value?.itemId && f.isPrimaryUOM)?.uom);
//         break;
//       case 'selectedUom':
//         setSelectedUom(value);
//         break;
//       case 'countQuantity':
//         setCountQuantity(value);
//         break;
//       default:
//         break;
//     }
//   };

//   const handleRemoveLine = (index: number) => {
//     const updatedLines = values.inventoryCountEntriesLineList?.filter((_: any, i: number) => i !== index);
//     formik.setFieldValue('inventoryCountEntriesLineList', updatedLines);
//   };

//   return (
//     <>
//       <div className='mb-3'>
//         <div className='d-flex align-items-center mb-3'>
//           <div className='w-50 me-2'>
//             <Select
//               classNamePrefix='react-select'
//               className='w-100'
//               isSearchable
//               isClearable
//               options={CountItemsOptions}
//               onChange={option => handleChange('selectedItem', option)}
//               value={selectedItem}
//               placeholder={i18n.language === 'ar' ? 'إختر الصنف' : 'Choose item'}
//               menuPortalTarget={document.body}
//               styles={{
//                 menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//               }}
// formatOptionLabel={option => (
//   <div className='d-flex justify-content-between align-items-center py-1'>
//     <div className='flex-grow-1'>
//       <div className='   '>{option.label}</div>
//       {/* {option.itemCode && ( */}
//       <small className='text-muted'>
//         {/* {t('ItemCode')} : {option.itemCode} */}
//         {t('ItemCode')} : 00
//       </small>
//       {/*  )} */}
//     </div>
//   </div>
// )}
//             />
//           </div>

//           <div className='w-20 me-2'>
//             <select
//               className='form-select text-center'
//               value={selectedUom}
//               onChange={e => handleChange('selectedUom', e.target.value)}
//             >
//               <option value=''>{i18n.language === 'ar' ? 'إختر الوحدة' : 'Choose unit'}</option>
//               {InventoryItemsOptions?.filter(f => f.itemId === selectedItem?.itemId)?.map((item, idx) => (
//                 <option key={idx} value={item.uom}>
//                   {item.uomName}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className='w-15 me-2'>
//             <input
//               type='text'
//               autoComplete='off'
//               className='form-control text-center'
//               placeholder={i18n.language === 'ar' ? 'الكمية' : 'Quantity'}
//               value={countQuantity}
//               onChange={e => handleChange('countQuantity', e.target.value.replace(/[^0-9]/g, ''))}
//             />
//           </div>

//           <button
//             type='button'
//             className='btn btn-theme w-15'
//             onClick={handleAddLine}
//             disabled={!selectedItem || !countQuantity || !selectedUom}
//           >
//             <i className='fas fa-plus me-1'></i>
//             {i18n.language === 'ar' ? 'إضافة' : 'Add'}
//           </button>
//         </div>

//         {/* جدول البنود المضافة */}
//         <div
//           className={`table-responsive rounded-2 ${
//             formik.errors.inventoryCountEntriesLineList ? 'border border-2 border-danger' : ''
//           }`}
//         >
//           <div
//             style={{
//               maxHeight: '350px',
//               overflowY: 'auto',
//               overflowX: 'auto',
//               position: 'relative'
//             }}
//           >
//             <table className='table table-hover mb-0'>
//               <thead
//                 className='table-active fw-bold sticky-top shadow'
//                 style={{
//                   backdropFilter: 'blur(20px)'
//                 }}
//               >
//                 <tr>
//                   <th className='fw-bold' style={{ width: '5%' }}>
//                     #
//                   </th>
//                   <th className='fw-bold' style={{ width: '50%' }}>
//                     {t('اسم الصنف')}
//                   </th>
//                   <th className='fw-bold' style={{ width: '20%' }}>
//                     {t('الوحدة')}
//                   </th>
//                   <th className='fw-bold text-center' style={{ width: '15%' }}>
//                     {t('رصيد الجرد')}
//                   </th>
//                   <th className='fw-bold text-center' style={{ width: '10%' }}>
//                     {t('إجراءات')}
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {values?.inventoryCountEntriesLineList?.length === 0 ? (
//                   <tr>
//                     <td colSpan={5} className='text-center py-4'>
//                       <i className='fas fa-inbox fa-2x text-muted mb-2'></i>
//                       <p className='text-muted mb-0'>{t('لا توجد بنود مضافة')}</p>
//                       <small className='text-muted'>{t('قم بإضافة بنود باستخدام النموذج أعلاه')}</small>
//                     </td>
//                   </tr>
//                 ) : (
//                   values?.inventoryCountEntriesLineList?.map((line: any, index: number) => (
//                     <tr key={index}>
//                       <td className='align-middle'>
//                         <span className='text-muted small'>{index + 1}</span>
//                       </td>
//                       <td className='align-middle'>
//                         <div className='fw-bold small'>{line.itemName}</div>
//                       </td>
//                       <td className='align-middle'>
//                         <span className='badge bg-secondary small'>{line.UomName}</span>
//                       </td>
//                       <td className='align-middle text-center'>
//                         <span className='badge bg-success fw-bold'>{line.countQuantity?.toLocaleString()}</span>
//                       </td>
//                       <td className='align-middle text-center'>
//                         <button
//                           type='button'
//                           className='btn btn-sm btn-outline-danger'
//                           onClick={() => handleRemoveLine(index)}
//                           title={i18n.language === 'ar' ? 'حذف' : 'Delete'}
//                         >
//                           <i className='fas fa-trash'></i>
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
// export default CountLine;

import React, { useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { type FormikProps } from 'formik';
import * as XLSX from 'xlsx';
import useGetInventoryCountById from '@hooks/INV/InventoryCount/useGetInventoryCountById';
import { useParams } from 'react-router-dom';
import useGetOnhandInventoryItemsByInventoryId from '@hooks/INV/MasterItems/useGetOnhandInventoryItemsByInventoryId';
import CustomAlert from '@components/Shared/Alert/CustomAlert';

interface LinesProps {
  formik: FormikProps<any>;
}

const CountLine: React.FC<LinesProps> = ({ formik }) => {
  const { values } = formik;
  const { invCountId } = useParams();
  const { CountItemsOptions, data } = useGetInventoryCountById({ invCountId });
  const { InventoryItemsOptions } = useGetOnhandInventoryItemsByInventoryId({
    InventoryId: data?.inventoryId
  });
  const OptionsItems = InventoryItemsOptions.filter(f => CountItemsOptions.some(s => s.inventoryItemId === f.itemId));

  const { i18n, t } = useTranslation();
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectedUom, setSelectedUom] = useState<any>(null);
  const [countQuantity, setCountQuantity] = useState<number | string>('');

  // ✅ إضافة صنف يدويًا
  const handleAddLine = () => {
    if (selectedItem && countQuantity !== '') {
      const newLine = {
        ItemId: selectedItem.value,
        invCountItemsId: selectedItem.invCountItemsId,
        countQuantity: Number(countQuantity),
        unitOfMeasure: selectedUom,
        itemName: OptionsItems.find(f => f.itemId === selectedItem.value)?.itemName,
        UomName: OptionsItems.find(f => f.uom === selectedUom)?.uomName
      };

      const updatedLines = [...(values.inventoryCountEntriesLineList || []), newLine];
      formik.setFieldValue('inventoryCountEntriesLineList', updatedLines);

      setSelectedItem(null);
      setSelectedUom(null);
      setCountQuantity('');
    }
  };

  const handleChange = (field: string, value: any) => {
    switch (field) {
      case 'selectedItem':
        setSelectedItem(value);
        setSelectedUom(OptionsItems?.find(f => f.itemId === value?.itemId && f.isPrimaryUOM)?.uom);
        break;
      case 'selectedUom':
        setSelectedUom(value);
        break;
      case 'countQuantity':
        setCountQuantity(value);
        break;
    }
  };

  const handleRemoveLine = (index: number) => {
    const updatedLines = values.inventoryCountEntriesLineList?.filter((_: any, i: number) => i !== index);
    formik.setFieldValue('inventoryCountEntriesLineList', updatedLines);
  };

  // ✅ استيراد من Excel (ItemCode + Quantity فقط)
  const handleImportExcel = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // 🔹 تحقق من الامتداد
    const validExtensions = ['xlsx', 'xls'];
    const fileExt = file.name.split('.').pop()?.toLowerCase();

    if (!validExtensions.includes(fileExt || '')) {
      CustomAlert({
        action: 'Error',
        Title: i18n.language === 'ar' ? 'نوع الملف غير مدعوم' : 'Unsupported file type',
        msg:
          i18n.language === 'ar'
            ? 'الرجاء رفع ملف Excel بامتداد xlsx أو xls فقط.'
            : 'Please upload an Excel file (.xlsx or .xls).',
        confirmButtonText: i18n.language === 'ar' ? 'حسنًا' : 'OK',
        Timer: 10000
      });

      e.target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = (event: any) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows: any[] = XLSX.utils.sheet_to_json(firstSheet, { defval: '' });

        // 🔹 تحقق من وجود بيانات
        if (!rows || rows.length === 0) {
          CustomAlert({
            action: 'info',
            Title: i18n.language === 'ar' ? 'الملف فارغ' : 'Empty file',
            msg:
              i18n.language === 'ar' ? 'لم يتم العثور على بيانات داخل الملف.' : 'No data found inside the Excel file.',
            confirmButtonText: i18n.language === 'ar' ? 'حسنًا' : 'OK',
            Timer: 10000
          });

          e.target.value = '';
          return;
        }

        // 🔹 تحقق من الأعمدة المطلوبة
        const requiredColumns = ['ItemCode', 'Quantity'];
        const fileColumns = Object.keys(rows[0]);

        const missingColumns = requiredColumns.filter(c => !fileColumns.includes(c));
        if (missingColumns.length > 0) {
          CustomAlert({
            action: 'Error',
            Title: i18n.language === 'ar' ? 'تنسيق الملف غير مطابق' : 'Invalid file format',
            msg:
              i18n.language === 'ar'
                ? `الملف يجب أن يحتوي على الأعمدة التالية: <b>${requiredColumns.join(', ')}</b>.`
                : `The file must contain the following columns: <b>${requiredColumns.join(', ')}</b>.`,
            confirmButtonText: i18n.language === 'ar' ? 'فهمت' : 'Got it',
            Timer: 10000
          });

          e.target.value = '';
          return;
        }

        // ✅ تحويل الصفوف إلى Lines
        const importedLines = rows.map((row: any, rowIndex: number) => {
          const code = row.ItemCode?.toString()?.trim();
          const qty = Number(row.Quantity);

          if (!code || isNaN(qty)) return null; // صف غير صالح

          const matchedItem = OptionsItems.find(f => f.itemCode?.trim() === code);
          const primaryUom = OptionsItems.find(u => u.itemId === matchedItem?.itemId && u.isPrimaryUOM);

          return {
            ItemId: matchedItem?.itemId || null,
            invCountItemsId: matchedItem?.itemId || null,
            countQuantity: qty,
            unitOfMeasure: primaryUom?.uom || matchedItem?.uom || null,
            itemName: matchedItem?.itemName || code,
            UomName: primaryUom?.uomName || ''
          };
        });

        // 🔹 استبعاد الصفوف الفارغة أو الخاطئة
        const validLines = importedLines.filter(l => l && l.ItemId !== null);

        if (validLines.length === 0) {
          CustomAlert({
            action: 'info',
            Title: i18n.language === 'ar' ? 'لم يتم مطابقة أي صنف' : 'No matching items found',
            msg:
              i18n.language === 'ar'
                ? 'لم يتم التعرف على أي صنف بناءً على الأكواد الموجودة في الملف.'
                : 'No items matched the ItemCodes in the file.',
            confirmButtonText: i18n.language === 'ar' ? 'حسنًا' : 'OK',
            Timer: 10000
          });

          e.target.value = '';
          return;
        }

        // ✅ دمج البيانات مع الموجودة
        const merged = [...(values.inventoryCountEntriesLineList || []), ...validLines];
        formik.setFieldValue('inventoryCountEntriesLineList', merged);

        // 🔹 عرض إشعار النجاح

        CustomAlert({
          action: 'Add',
          Title: i18n.language === 'ar' ? 'تم الاستيراد بنجاح' : 'Import Successful',
          htmlContent:
            i18n.language === 'ar'
              ? `تم استيراد <b>${validLines.length}</b> صنف بنجاح.`
              : `Successfully imported <b>${validLines.length}</b> items.`,

          confirmButtonText: i18n.language === 'ar' ? 'رائع' : 'Great',
          Timer: 10000
        });

        e.target.value = '';
      } catch (err) {
        CustomAlert({
          action: 'Error',
          Title: i18n.language === 'ar' ? 'خطأ أثناء قراءة الملف' : 'Error reading file',
          msg:
            i18n.language === 'ar'
              ? 'حدث خطأ غير متوقع أثناء معالجة الملف، الرجاء التأكد من صحة الصيغة.'
              : 'Unexpected error occurred while processing the file.',

          confirmButtonText: i18n.language === 'ar' ? 'حسنًا' : 'OK',
          Timer: 10000
        });

        e.target.value = '';
      }
    };

    reader.readAsArrayBuffer(file);
  };

  // ✅ تحميل القالب Excel Template
  const handleDownloadTemplate = () => {
    const sampleData = [
      { ItemCode: 'ITEM001', Quantity: 10 },
      { ItemCode: 'ITEM002', Quantity: 25 }
    ];

    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');

    // تنسيق الأعمدة
    worksheet['!cols'] = [
      { wch: 20 }, // ItemCode
      { wch: 15 } // Quantity
    ];

    // العناوين بالخط العريض
    const header = ['ItemCode', 'Quantity'];
    header.forEach((key, idx) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: idx });
      if (!worksheet[cellRef]) return;
      worksheet[cellRef].s = {
        font: { bold: true, color: { rgb: 'FFFFFF' } },
        fill: { fgColor: { rgb: '4472C4' } },
        alignment: { horizontal: 'center' }
      };
    });

    XLSX.writeFile(workbook, 'InventoryCountTemplate.xlsx');
  };

  return (
    <>
      <div className='mb-3'>
        {/* ✅ زر استيراد من Excel */}
        <div className='d-flex justify-content-end gap-2 mb-2'>
          <button type='button' className='btn btn-sm btn-outline-primary' onClick={handleDownloadTemplate}>
            <i className='fas fa-download me-2'></i>
            {i18n.language === 'ar' ? 'تحميل القالب' : 'Download Template'}
          </button>

          <label className='btn btn-sm btn-outline-secondary mb-0'>
            <i className='fas fa-file-excel me-2 text-success'></i>
            {i18n.language === 'ar' ? 'استيراد من Excel' : 'Import from Excel'}
            <input type='file' accept='.xlsx, .xls' onChange={handleImportExcel} style={{ display: 'none' }} />
          </label>
        </div>

        <div className='d-flex align-items-center mb-3 flex-wrap gap-2'>
          {/* 🔹 اختيار الصنف */}
          <div className='w-45 me-2'>
            <Select
              classNamePrefix='react-select'
              className='w-100'
              isSearchable
              isClearable
              options={OptionsItems?.filter(
                (item, index, self) => index === self?.findIndex(i => i.itemId === item.itemId)
              )}
              onChange={option => handleChange('selectedItem', option)}
              value={selectedItem}
              placeholder={i18n.language === 'ar' ? 'إختر الصنف' : 'Choose item'}
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              formatOptionLabel={option => (
                <div className='d-flex justify-content-between align-items-center py-1'>
                  <div className='flex-grow-1'>
                    <div className=' '>{option.label}</div>
                    <small className='text-muted'>
                      {t('ItemCode')} : {option.itemCode}
                      {/* {t('ItemCode')} : 00 */}
                    </small>
                  </div>
                </div>
              )}
            />
          </div>

          {/* 🔹 الوحدة */}
          <div className='w-20 me-2'>
            <select
              className='form-select text-center'
              value={selectedUom}
              onChange={e => handleChange('selectedUom', e.target.value)}
            >
              <option value=''>{i18n.language === 'ar' ? 'إختر الوحدة' : 'Choose unit'}</option>
              {OptionsItems?.filter(f => f.itemId === selectedItem?.itemId)?.map((item, idx) => (
                <option key={idx} value={item.uom}>
                  {item.uomName}
                </option>
              ))}
            </select>
          </div>

          {/* 🔹 الكمية */}
          <div className='w-15 me-2'>
            <input
              type='text'
              autoComplete='off'
              className='form-control text-center'
              placeholder={i18n.language === 'ar' ? 'الكمية' : 'Quantity'}
              value={countQuantity}
              onChange={e => handleChange('countQuantity', e.target.value.replace(/[^0-9]/g, ''))}
            />
          </div>

          {/* 🔹 زر الإضافة */}
          <button
            type='button'
            className='btn btn-theme w-15'
            onClick={handleAddLine}
            disabled={!selectedItem || !countQuantity || !selectedUom}
          >
            <i className='fas fa-plus me-1'></i>
            {i18n.language === 'ar' ? 'إضافة' : 'Add'}
          </button>
        </div>

        {/* 🔹 جدول البنود */}
        <div
          className={`table-responsive rounded-2 ${
            formik.errors.inventoryCountEntriesLineList ? 'border border-2 border-danger' : ''
          }`}
        >
          <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
            <table className='table table-hover mb-0'>
              <thead className='table-active fw-bold sticky-top shadow' style={{ backdropFilter: 'blur(20px)' }}>
                <tr>
                  <th>#</th>
                  <th>{t('اسم الصنف')}</th>
                  <th>{t('الوحدة')}</th>
                  <th className='text-center'>{t('رصيد الجرد')}</th>
                  <th className='text-center'>{t('إجراءات')}</th>
                </tr>
              </thead>
              <tbody>
                {values?.inventoryCountEntriesLineList?.length === 0 ? (
                  <tr>
                    <td colSpan={5} className='text-center py-4 text-muted'>
                      <i className='fas fa-inbox fa-2x mb-2'></i>
                      <p className='mb-0'>{t('لا توجد بنود مضافة')}</p>
                    </td>
                  </tr>
                ) : (
                  values?.inventoryCountEntriesLineList?.map((line: any, index: number) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{line.itemName}</td>
                      <td>{line.UomName}</td>
                      <td className='text-center'>{line.countQuantity}</td>
                      <td className='text-center'>
                        <button
                          type='button'
                          className='btn btn-sm btn-outline-danger'
                          onClick={() => handleRemoveLine(index)}
                        >
                          <i className='fas fa-trash'></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CountLine;
